import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import notFound404Rafiki from "@icons/errors/404-error-rafiki.svg";
import notFound404PlugAmico from "@icons/errors/404-page-not-found-plug-amico.svg";
import notFound404PlugBro from "@icons/errors/404-page-not-found-plug-bro.svg";
import notFound404PlugPana from "@icons/errors/404-page-not-found-plug-pana.svg";
import notFound404CuteAnimal from "@icons/errors/404-cute-animal-bro.svg";
import notFound404LostInSpaceBro from "@icons/errors/404-lost-in-space-bro.svg";
import notFound404LostInSpaceCuate from "@icons/errors/404-lost-in-space-cuate.svg";
import notFound404TiredPerson from "@icons/errors/404-error-with-a-tired-person-animate.svg";
import notFound404TiredPerson2 from "@icons/errors/404-tired-person-animate-2.svg";
import notFound404LookingFor from "@icons/errors/404-error-with-person-looking-for-animate.svg";
import serverError500Animation from "@icons/errors/500-internal-server-error-animate.svg";
import serverError500Animation1 from "@icons/errors/500-internal-server-error-animate-1.svg";
import serverError500PlugRafiki from "@icons/errors/500-page-not-found-plug-rafiki.svg";
import serverError500BrokenRobotAmico from "@icons/errors/500-broken-robot-amico.svg";
import serverError500BrokenRobotBro from "@icons/errors/500-broken-robot-bro.svg";
import serverError500BrokenRobotPana from "@icons/errors/500-broken-robot-pana.svg";

// Multiple illustrations per error code so a different one can be picked at
// random each time the page is rendered, instead of the caller having to
// pass the illustration explicitly.
const ILLUSTRATIONS_BY_CODE = {
  404: [
    notFound404Rafiki,
    notFound404PlugAmico,
    notFound404PlugBro,
    notFound404PlugPana,
    notFound404CuteAnimal,
    notFound404LostInSpaceBro,
    notFound404LostInSpaceCuate,
    notFound404TiredPerson,
    notFound404TiredPerson2,
    notFound404LookingFor,
  ],
  500: [
    serverError500PlugRafiki,
    serverError500BrokenRobotAmico,
    serverError500BrokenRobotBro,
    serverError500BrokenRobotPana,
    serverError500Animation,
    serverError500Animation1,
  ],
};

const pickRandomIllustration = (code) => {
  const illustrations = ILLUSTRATIONS_BY_CODE[code] || ILLUSTRATIONS_BY_CODE[500];
  return illustrations[Math.floor(Math.random() * illustrations.length)];
};

const ErrorPage = ({ t, code, title, message, showHomeButton }) => {
  const illustration = useMemo(() => pickRandomIllustration(code), [code]);

  return (
    <div className="error-page">
      <div className="error-page__illustration">
        <img src={illustration} alt={t(title)} />
      </div>

      <div className="error-page__content">
        {/* <span className="error-page__code">{code}</span> */}
        <h1 className="error-page__title">{t(title)}</h1>
        <p className="error-page__message">{t(message)}</p>
        {showHomeButton && (
          <Link className="error-page__home-btn" to="/">
            {t("BACK_TO_HOME")}
          </Link>
        )}
      </div>
    </div>
  );
};

ErrorPage.propTypes = {
  t: PropTypes.func.isRequired,
  code: PropTypes.string,
  title: PropTypes.string,
  message: PropTypes.string,
  showHomeButton: PropTypes.bool,
};

ErrorPage.defaultProps = {
  code: "",
  title: "GENERIC_SOMETHING_WENT_WRONG_TITLE",
  message: "GENERIC_SOMETHING_WENT_WRONG_MESSAGE",
  showHomeButton: true,
};

export default withTranslation()(ErrorPage);
